import { render } from "./OverdueReport.vue?vue&type=template&id=c36a7698"
import script from "./OverdueReport.vue?vue&type=script&lang=js"
export * from "./OverdueReport.vue?vue&type=script&lang=js"

import "./OverdueReport.vue?vue&type=style&index=0&id=c36a7698&lang=css"
script.render = render

export default script